namespace SorAraBul.Administration {
    export interface BuyCreditResponse extends Serenity.ServiceResponse {
        Credit?: number;
    }
}
